import React, { useEffect } from 'react';
import {
    changeNameAll,
    changeTitle1All,
    changePhoneAll,
    changeFaxAll,
    changeAddressAll,
    changeCityAll,
    changeStateAll,
    changeZipAll,
    changeOpen1All,
} from './../CanvasActions';
import TextField from './../Form/TextField';
import SelectField from './../Form/SelectField';

const FormP1T14 = React.memo((props) => {
    useEffect(() => {
        changeNameAll(props.name);
    }, [props.name]);

    useEffect(() => {
        changeTitle1All(props.title1);
    }, [props.title1]);

    useEffect(() => {
        changePhoneAll(props.phone);
    }, [props.phone]);

    useEffect(() => {
        changeFaxAll(props.fax);
    }, [props.fax]);

    useEffect(() => {
        changeAddressAll(props.address);
    }, [props.address]);

    useEffect(() => {
        changeCityAll(props.city);
    }, [props.city]);

    useEffect(() => {
        changeStateAll(props.state);
    }, [props.state]);

    useEffect(() => {
        changeZipAll(props.zip);
    }, [props.zip]);

    useEffect(() => {
        changeOpen1All(props.open1);
    }, [props.open1]);

    return (
        <form action="">
            <hr />
            <TextField
                required
                label="Name 1"
                // limit={33}
                value={props.name}
                setFunction={props.setName}
                placeholder="Clinic Name or Specialty line 1"
            />
            <TextField
                label="Name 2"
                // limit={33}
                value={props.title1}
                setFunction={props.setTitle1}
                placeholder="Clinic Name or Specialty line 2"
            />
            <TextField
                required
                isPhone
                phoneFormat={2}
                label="Phone"
                value={props.phone}
                setFunction={props.setPhone}
                placeholder="Main or direct phone number"
            />
            <TextField
                isPhone
                phoneFormat={2}
                label="Fax"
                value={props.fax}
                setFunction={props.setFax}
                placeholder="Fax number"
            />
            <hr />
            <TextField
                required
                label="Address 1"
                // limit={36}
                value={props.address}
                setFunction={props.setAddress}
                placeholder="Address Line 1"
            />
            <TextField
                label="Suite/Building #"
                // limit={36}
                value={props.open1}
                setFunction={props.setOpen1}
                placeholder="Suite/Building #"
            />
            <TextField
                required
                label="City"
                // limit={16}
                value={props.city}
                setFunction={props.setCity}
            />
            <TextField
                required
                label="State"
                // limit={16}
                value={props.state}
                setFunction={props.setState}
            />
            <TextField
                required
                label="Zip"
                // limit={10}
                value={props.zip}
                setFunction={props.setZip}
            />
            <hr />
            <SelectField
                required
                label="Quantity"
                value={props.quantity}
                setFunction={props.setQuantity}
                options={[
                    { value: '', label: 'Select option' },
                    { value: '250', label: '250' },
                    { value: '500', label: '500' },
                    { value: '1000', label: '1000' },
                ]}
            />
            <hr />
            <h5 className="description-header">Description</h5>
            <div className="description-section">
                <div><span className="label">Title:</span> UTHealth and UT Physicians Clinic Appointment Card Reminder</div>
                <div className="description-list">
                    <span className="label">Description:</span>
                    <ul>
                        <li>Variables one side</li>
                        <li>Size 3.5x2</li>
                        <li>Double sided </li>
                        <li>Color on both sides</li>
                        <li>#80 Avalanche Smooth Cover</li>
                    </ul>
                </div>
            </div>
        </form>
    );
});

FormP1T14.propTypes = {

}

export default FormP1T14;
